var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8501 6.00635C7.8501 5.71859 7.73665 5.4668 7.50977 5.25098L2.5376 0.328613C2.35498 0.145996 2.13363 0.0546875 1.87354 0.0546875C1.60238 0.0546875 1.37272 0.148763 1.18457 0.336914C0.996419 0.519531 0.902344 0.743652 0.902344 1.00928C0.902344 1.2749 1.00472 1.51009 1.20947 1.71484L5.56738 6.00635L1.20947 10.2979C1.00472 10.5026 0.902344 10.7378 0.902344 11.0034C0.902344 11.269 0.996419 11.4959 1.18457 11.6841C1.37272 11.8667 1.60238 11.958 1.87354 11.958C2.13363 11.958 2.35498 11.8667 2.5376 11.6841L7.50977 6.76172C7.62598 6.64551 7.71175 6.52653 7.76709 6.40479C7.82243 6.28304 7.8501 6.15023 7.8501 6.00635Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.141966403135ad9d31c2e751e85c51b5.svg";
export { ForwardRef as ReactComponent };